import * as p from 'store/Global/types';

// eslint-disable-next-line import/prefer-default-export
export const toggleExpandCollapse = (tab, fields) => {
  return async (dispatch) => {
    dispatch({ type: p.EXPAND_COLLAPSE, tab, fields });
  };
};
